import { SingleLaunchResponse } from 'src/services/responseTypes/singleLaunchResponse';
import { mixpanelObject } from 'src/utils/analytics';
import { clearCtaEventsProperty } from 'src/utils/analytics/mixpanel/mixpanelHelper';
import { isTelcoUser } from 'src/utils/auth-utils/checkTelcoUser';
import { getCookie, getSessionStorage } from 'src/utils/browserStorageHandler';
import { isServer } from 'src/utils/common';
import { DynamicObject } from 'src/utils/commonTypes';
import { PARTNER, WEBVIEW } from 'src/utils/constants/cookieConstants';
import { PARTNER_NAME } from 'src/utils/constants/localStorageConstants';
import { ProfileMenuLinks } from 'src/utils/constants/RouterConstants';
import { PartnerPlatforms } from 'src/utils/constants/stringConstants';

import { ctaEvent } from '../../utils/analytics/mixpanel/mixpanelEventsHelper';
import {
  MIXPANEL_ELEMENT,
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_HEADER,
  MIXPANEL_HORIZONTAL_INDEX
} from '../../utils/analytics/mixpanel/mixpanelConstants';

export const getProfileMenuList = (
  HeaderStrings: DynamicObject,
  initialLaunchData: SingleLaunchResponse,
  isUserLoggedIn: boolean,
  predictWinFlag: boolean
) => {
  const isUsReferral = initialLaunchData?.countrylist[0]?.us_referral;
  const menuCollection =
    initialLaunchData?.countrylist[0]?.menu_options.collection_sequence
      .web_app || {};
  const isPlexVisible = Object.values(menuCollection).includes('plex');

  const telcoUser = isTelcoUser();

  const profileMenuList = [
    {
      name: HeaderStrings.MY_WATCHLIST,
      link: ProfileMenuLinks.WATCH_LIST,
      isActive: false
    },
    !telcoUser
      ? {
          name: HeaderStrings.MY_SUBSCRIPTION,
          link: ProfileMenuLinks.PLANS,
          isActive: false
        }
      : undefined,
    isPlexVisible
      ? {
          name: HeaderStrings.MY_RENTALS,
          link: ProfileMenuLinks.RENTALS,
          isActive: false
        }
      : undefined,
    !telcoUser
      ? {
          name: HeaderStrings.MY_TRANSACTION,
          link: ProfileMenuLinks.PAYMENTS,
          isActive: false
        }
      : undefined,
    !telcoUser
      ? {
          name: HeaderStrings.MANAGE_YOUR_DEVICES,
          link: ProfileMenuLinks.MANAGE_DEVICES,
          isActive: false
        }
      : undefined,
    predictWinFlag && !telcoUser
      ? {
          name: HeaderStrings.LEADERBOARD,
          link: ProfileMenuLinks.LEADERBOARD_LINK,
          isActive: false
        }
      : undefined,
    isUsReferral
      ? {
          name: HeaderStrings.USREFERRAL_INVITE,
          link: ProfileMenuLinks.USREFERRAL,
          isActive: false
        }
      : undefined
  ];
  if (!isServer()) {
    // we are not showing logout for Samsung and tatasky user
    if (
      getCookie(WEBVIEW) !== 'true' &&
      getCookie(PARTNER) !== PartnerPlatforms.SAMSUNG_MY_GALAXY_APP &&
      getSessionStorage(PARTNER_NAME) !== PartnerPlatforms.TATASKY_PARTNER
    ) {
      profileMenuList.push({
        name: HeaderStrings.LOGOUT,
        link: ProfileMenuLinks.LOGOUT_LINK,
        isActive: false
      });
    }

    // SamsungLogin web view
    if (
      isUserLoggedIn &&
      getCookie(WEBVIEW) === 'true' &&
      getCookie(PARTNER) === PartnerPlatforms.SAMSUNG_MY_GALAXY_APP
    ) {
      profileMenuList.splice(4, 1);
    }
  }

  return profileMenuList;
};

export const profileMenuMixpanelEvent = (element: string) => {
  const profileMenuIndex = '0';
  // mixpanel Initailization start
  clearCtaEventsProperty(mixpanelObject);
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, element);
  mixpanelObject.setProperty(MIXPANEL_BUTTON_TYPE, MIXPANEL_HEADER);
  mixpanelObject.setProperty(MIXPANEL_HORIZONTAL_INDEX, profileMenuIndex);
  ctaEvent();
  // mixpanel Initailization end
};
